import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import { Language, languageResource } from "@megarax/client/src/resources/plm";
import { getDefaultModuleComponents } from "@/components/nameResource/components";

export const languageModule: ResourceAppModule = {
  ...getDefaultModuleComponents(languageResource),
  route: "jezyk",
  title: "Jezyki",
  app: plmApp,
  itemConstructor: Language,
  resource: languageResource,
  iconClass: "fas fa-language fa-fw",
};
